import styled from "styled-components";

function SoftDrinks({}) {
    return (
        <>
        </>
    )
}

export default SoftDrinks;